import { useQuery } from '@tanstack/react-query';
import { getBookById } from 'api/auth.api';

export const useBookById = (id) => {
  return useQuery({
    queryKey: ['bookById', id],
    queryFn: () => getBookById(id),
    enabled: !!id,
  });
};
